/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferredProjectDeliverableTaxResource
 */
export interface ReferredProjectDeliverableTaxResource {
    /**
     * 
     * @type {string}
     * @memberof ReferredProjectDeliverableTaxResource
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferredProjectDeliverableTaxResource
     */
    descriptionKey?: string;
    /**
     * 
     * @type {number}
     * @memberof ReferredProjectDeliverableTaxResource
     */
    rate: number;
    /**
     * 
     * @type {string}
     * @memberof ReferredProjectDeliverableTaxResource
     */
    type: ReferredProjectDeliverableTaxResourceTypeEnum;
}


/**
 * @export
 */
export const ReferredProjectDeliverableTaxResourceTypeEnum = {
    Other: 'OTHER',
    Vat: 'VAT'
} as const;
export type ReferredProjectDeliverableTaxResourceTypeEnum = typeof ReferredProjectDeliverableTaxResourceTypeEnum[keyof typeof ReferredProjectDeliverableTaxResourceTypeEnum];


/**
 * Check if a given object implements the ReferredProjectDeliverableTaxResource interface.
 */
export function instanceOfReferredProjectDeliverableTaxResource(value: object): value is ReferredProjectDeliverableTaxResource {
    if (!('rate' in value) || value['rate'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ReferredProjectDeliverableTaxResourceFromJSON(json: any): ReferredProjectDeliverableTaxResource {
    return ReferredProjectDeliverableTaxResourceFromJSONTyped(json, false);
}

export function ReferredProjectDeliverableTaxResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferredProjectDeliverableTaxResource {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'descriptionKey': json['descriptionKey'] == null ? undefined : json['descriptionKey'],
        'rate': json['rate'],
        'type': json['type'],
    };
}

export function ReferredProjectDeliverableTaxResourceToJSON(value?: ReferredProjectDeliverableTaxResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'descriptionKey': value['descriptionKey'],
        'rate': value['rate'],
        'type': value['type'],
    };
}

